import { sessionPrefix } from "./helpers";

export const customerFeedbacksPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/customer-feedbacks`;

export const importCustomerFeedbacksPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/customer-feedbacks/import`;

export const showCustomerFeedbackPath = (session: LightSessionInterface, feedback: CustomerFeedbackRef) =>
  `${sessionPrefix(session)}/customer-feedbacks/${feedback.id}`;

export const customerFeedbackTopicsPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/customer-feedbacks/topics`;

export const newCustomerFeedbackTopicPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/customer-feedbacks/topics/new`;

export const editCustomerFeedbackTopicPath = (session: LightSessionInterface, topic: CustomerFeedbackTopicRef) =>
  `${sessionPrefix(session)}/customer-feedbacks/topics/${topic.id}`;
